var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';
import 'whatwg-fetch';

var alternativeSpriteSets = ['marketing'];

var MalibuSprites = (_temp2 = _class = function (_React$Component) {
  _inherits(MalibuSprites, _React$Component);

  function MalibuSprites() {
    var _temp, _this, _ret;

    _classCallCheck(this, MalibuSprites);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      fetchTries: 0,
      sprites: ''
    }, _this.fetchSprites = function () {
      var _this$props = _this.props,
          version = _this$props.version,
          set = _this$props.set;

      var file = set ? set + '/sprite.svg' : 'sprite.svg';

      fetch('https://www.herokucdn.com/malibu/' + version + '/' + file).then(function (res) {
        return res.text();
      }).then(function (sprites) {
        _this.setState({
          fetchTries: 0,
          sprites: sprites
        });
      }).catch(function (err) {
        // Retry with exponential backoff
        var fetchTries = _this.state.fetchTries;

        fetchTries += 1;
        _this.setState({ fetchTries: fetchTries });
        var fetchDelaySeconds = Math.pow(2, fetchTries);
        console.warn('Error when fetching Malibu sprites, retrying in ' + Math.pow(2, fetchTries), err);
        setTimeout(_this.fetchSprites, Math.pow(fetchDelaySeconds, 1000));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MalibuSprites.prototype.componentDidMount = function componentDidMount() {
    this.fetchSprites();
  };

  MalibuSprites.prototype.componentDidUpdate = function componentDidUpdate() {
    this.props.handleUpdate();
  };

  MalibuSprites.prototype.render = function render() {
    var sprites = this.state.sprites;

    return React.createElement(SVGInline, { svg: sprites });
  };

  return MalibuSprites;
}(React.Component), _class.defaultProps = {
  handleUpdate: function handleUpdate() {},
  version: 'latest'
}, _temp2);
export { MalibuSprites as default };
MalibuSprites.propTypes = process.env.NODE_ENV !== "production" ? {
  handleUpdate: PropTypes.func,
  version: PropTypes.string.isRequired,
  set: PropTypes.oneOf(alternativeSpriteSets)
} : {};